import React, { useState } from 'react';
import classNames from 'classnames';
import { store } from '../../../../store';
import AuthService from '../../../../services/AuthService';
import { logout } from '../../../../store/modules/auth/actions';
// import iconProfile from '../../../../assets/images/profile.png';
import history from '../../../../services/history';

export function Profile(props) {
  const { hiddeMenu } = props;
  const [expanded, setExpanded] = useState(false);

  function onClick(event) {
    setExpanded(!expanded);
    event.preventDefault();
  }

  const handleLogout = () => {
    store.dispatch(logout());
  };

  const colaborador = AuthService.getColaborador();
  const apiInfo = AuthService.getApiInfo();
  const versionText = apiInfo && apiInfo.versionText ? apiInfo.versionText : '';
  // console.log(apiInfo);
  return (
    <div className="layout-profile">
      {/* <div>
        <img src={iconProfile} alt="" />
      </div> */}
      <button className="p-link layout-profile-link" onClick={onClick}>
        <span className="username">{colaborador?.nome}</span>

        <i className="pi pi-fw pi-cog" />
        <span
          className="username"
          style={{ fontSize: 11, display: 'block', textAlign: 'center' }}
        >
          Versão {versionText}
        </span>
      </button>
      <ul
        className={classNames({
          'layout-profile-expanded': expanded,
        })}
      >
        <li>
          <button
            className="p-link"
            onClick={() => {
              if (hiddeMenu) {
                hiddeMenu();
              }
              history.push(`/colaboradores/${AuthService.getColaborador()?.id}?toBack=/home`);
            }}
          >
            <i className="pi pi-fw pi-user" />
            <span>Conta</span>
          </button>
        </li>
        <li>
          <button className="p-link" onClick={() => handleLogout()}>
            <i className="pi pi-fw pi-power-off" />
            <span>Sair</span>
          </button>
        </li>
      </ul>
    </div>
  );
}
